var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditStationSequence = function SvgEditStationSequence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.0000755px",
    height: "13.624424px",
    viewBox: "0 0 14.0000755 13.624424",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.2.9-Setup-/-Company-/-Company-details---create-project--view-action",
    transform: "translate(-1006.999995, -600.700458)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-action",
    transform: "translate(988.000000, 526.511337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(0.000000, 14.001075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-2",
    transform: "translate(16.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.Icon/01.Basic/Fill/20/eye-Copy",
    transform: "translate(2.999995, 3.188046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.505317756,2.35382916 C0.192053504,2.53214174 -0.0010046921,2.86524772 0,3.22570416 L0,12.4994542 C-0.0011315395,12.8509217 0.182327958,13.1771833 0.483229158,13.3588124 C0.784130359,13.5404415 1.15829257,13.5507698 1.46875526,13.3860167 C1.48219276,13.3788292 1.49531776,13.3713292 1.50813026,13.3628917 L4.13750528,11.6425792 C4.20844906,11.596314 4.25114401,11.5172754 4.25094377,11.4325792 L4.25094377,0.263516642 C4.25120333,0.170702097 4.20002259,0.0853825184 4.11801304,0.0419194217 C4.03600348,-0.00154367499 3.93666508,0.00400436913 3.86000528,0.0563291407 L0.505317756,2.35382916 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63625529,0.0403916406 C5.55947116,-0.0095198734 5.46154219,-0.013452954 5.38100267,0.0301400355 C5.30046316,0.0737330251 5.25020534,0.157874002 5.25000458,0.249454142 L5.25000458,11.4232042 C5.24980405,11.5079004 5.29249901,11.586939 5.36344279,11.6332042 L8.3634428,13.5838292 C8.44028585,13.6339419 8.53840342,13.6379417 8.61907037,13.5942498 C8.69973732,13.5505579 8.75000458,13.4661937 8.75000458,13.3744542 L8.75000458,2.20789165 C8.7502439,2.12302445 8.70741153,2.04383163 8.63625531,1.99757915 L5.63625529,0.0403916406 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5165678,0.264141642 C13.2166718,0.0806040941 12.8418679,0.0701333824 12.5321928,0.236641642 C12.5187195,0.243558749 12.5056751,0.251281063 12.4931303,0.259766642 L9.86344281,1.97851665 C9.79249903,2.02478185 9.74980408,2.10382044 9.75000363,2.18851665 L9.75000363,13.3591417 C9.74966488,13.4520626 9.80088926,13.5375059 9.88300738,13.5809917 C9.9651255,13.6244776 10.0645871,13.6188305 10.1412553,13.5663292 L13.4871928,11.2707042 C13.8043259,11.0937855 14.0006233,10.7588478 14.0000053,10.3957042 L14.0000053,1.14570415 C14.0041916,0.787508134 13.8208492,0.453177987 13.5165678,0.264141642 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditStationSequence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-station-sequence.017e0f6e.svg";
export { ForwardRef as ReactComponent };